import { dataFastRewind } from 'dls-icons-data'
import { createIcon } from '../common'

const IconFastRewind = /*#__PURE__*/createIcon(dataFastRewind)
export default IconFastRewind
